import Base from '../Base';

export default class User extends Base {
  constructor(item) {
    super(item.id, '/users');
    const info = item.info || {};
    this.full_name = info.full_name;
    this.last_name = info.surname;
    this.first_name = info.first_name;
    this.middle_name = info.patronymic;
    this.groups = item.groups || [];
    this.name = item.name;
    this.number = item.number;
    this.email = item.email;
    this.settings = item.settings;
    this.telegram = item.telegram;
  }
}
